import { INeoAction } from '~/store/Actions.interface';
import { REQUEST_ACTIONS, STATIC_ACTIONS, STATUS } from '~/Constants/Actions.constants';
import { AccessRoles, FitogramVersion } from '~/Hooks/useHasAccess/accessList.types';
import { ProviderAccessType } from '~/Models/DTO/Provider.model';

export interface IMockAccessRoles {
  isInMockMode: boolean;
  userView: AccessRoles;
  appView: FitogramVersion;
  providerId: string;
  defaultAppView?: FitogramVersion;
}

export default (
  state: IMockAccessRoles = {
    isInMockMode: false,
    userView: AccessRoles.FITOGRAM_SUPER_ADMIN,
    appView: FitogramVersion.Neo,
    providerId: '',
    defaultAppView: FitogramVersion.Neo,
  },
  action: INeoAction,
): IMockAccessRoles => {
  const { name, payload, status } = action;

  if (status === STATUS.SUCCESS) {
    switch (name) {
      case STATIC_ACTIONS.UPDATE_MOCK_ACCESS_IS_IN_MOCK_MODE:
        return {
          ...state,
          isInMockMode: payload,
          userView: AccessRoles.FITOGRAM_SUPER_ADMIN,
          appView: state.defaultAppView || FitogramVersion.Neo,
        };
      case STATIC_ACTIONS.UPDATE_MOCK_ACCESS_USER_VIEW:
        return {
          ...state,
          isInMockMode: true,
          userView: payload,
        };
      case STATIC_ACTIONS.UPDATE_MOCK_ACCESS_APP_VIEW:
        return {
          ...state,
          isInMockMode: true,
          appView: payload,
        };
      case REQUEST_ACTIONS.GET_PROVIDER:
      case REQUEST_ACTIONS.UPDATE_PROVIDER:
        if (state.providerId !== payload?.uuid)
          return {
            isInMockMode: false,
            userView: AccessRoles.FITOGRAM_SUPER_ADMIN,
            appView:
              payload?.accessType === ProviderAccessType.FULL
                ? FitogramVersion.Neo
                : FitogramVersion.PartnerTool,
            providerId: payload?.uuid,
            defaultAppView:
              payload?.accessType === ProviderAccessType.FULL
                ? FitogramVersion.Neo
                : FitogramVersion.PartnerTool,
          };
        return state;
    }
  }
  return state;
};
